export default {
  mantenedorCategorias: (state) => {
    const categories = state.herramientas.mantenedores.categorias || {};
    const categoriesList = Object.values(categories)
      .map((category) => ({ ...category }))
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
    return categoriesList;
  },
  mantenedorDocumentos: (state) => {
    const documents = state.herramientas.mantenedores.documentos || {};
    const documentsList = Object.values(documents)
      .map((doc) => ({ ...doc }))
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
    return documentsList;
  },
  loading: (state) => state.loading,
  selectedCategory: (state) => state.category,
  selectedInstitution: (state) => state.institution,
  categoryInstitutions: (state) => {
    const categories = state.herramientas.mantenedores.categoryInstitutions || {};
    return Object.values(categories)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  mantenedorInstitutions: (state) => {
    const institutions = state.herramientas.mantenedores.institutions || {};
    return Object.values(institutions)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  selectedSubject: (state) => state.subject,
  categorySubjects: (state) => {
    const categories = state.herramientas.mantenedores.categorySubjects || {};
    return Object.values(categories)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  selectedTypeAttachment: (state) => state.service,
  typeAttachments: (state) => {
    const categories = state.herramientas.mantenedores.categoryTypeAttachments || {};
    return Object.values(categories);
  },
  selectedService: (state) => state.service,
  categoryServices: (state) => {
    const categories = state.herramientas.mantenedores.categoryServices || {};
    return Object.values(categories);
  },
  selectedRegion: (state) => state.region,
  categoryRegions: (state) => {
    const categories = state.herramientas.mantenedores.categoryRegions || {};
    return Object.values(categories);
  },
  mantenedorSubjects: (state) => {
    const subjects = state.herramientas.mantenedores.subjects || {};
    return Object.values(subjects)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  selectedActivity: (state) => state.activity,
  categoryActivities: (state) => {
    const categories = state.herramientas.mantenedores.categoryActivities || {};
    return Object.values(categories)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  activityStates: (state) => {
    const states = state.herramientas.mantenedores.activityStates || {};
    return Object.values(states)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  selectedState: (state) => state.kanbanState,
  categoryStates: (state) => {
    const states = state.herramientas.mantenedores.categoryStates || {};
    return Object.values(states)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  subStateStates: (state) => {
    const states = state.herramientas.mantenedores.subStateStates || {};
    return Object.values(states)
      .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b));
  },
  categoryRetentionPercentage: (state) => {
    const percentages = state.herramientas.mantenedores.categoryRetentionPercentage || {};
    return Object.values(percentages);
  }
};
